<template>
  <div class="backdrop">
    <div class="popup">
      <i class="bi bi-x" @click="close"></i>
      <div class="content">
        <div
          class="manchete"
          v-if="content.manchete"
          v-html="content.manchete"
        ></div>
        <div class="data-e-fonte">
          <div v-if="content.data" class="data">[{{ content.data }}]</div>
          <a class="font" :href="content.link" target="_blank"
            ><i class="bi bi-link-45deg"></i>
            {{ content.link2 ? "Instagram" : "Fonte" }}</a
          >
          <a
            v-if="content.link2"
            class="font"
            :href="content.link2"
            target="_blank"
            ><i class="bi bi-link-45deg"></i> Fonte</a
          >
        </div>
        <img
          v-if="content.image"
          :src="content.image"
          alt="image"
          class="image-noticia"
        />
        <div class="descricao" v-html="content.descricao"></div>
        <div v-show="showProximo" class="btn-controls">
          <div class="button" @click="anterior" :class="{ disabled: i === 0 }">
            anterior <i class="icon-l bi bi-arrow-left"></i>
          </div>
          <div
            class="button"
            @click="proximo"
            :class="{ disabled: i === noticias.length - 1 }"
          >
            <i class="icon-r bi bi-arrow-right"></i>proximo
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scaleOut, scaleIn } from "@/assets/animate";
export default {
  name: "PopUpCinza",
  props: {
    noticias: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
    isShowed: {
      type: Boolean,
      required: false,
      default: true,
    },
    showProximo: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    isShowed(val, old) {
      if (!old && val) {
        this.showed = true;
        this.showAnimation();
      } else if (old && !val) {
        this.showed = false;
      }
    },
  },
  data() {
    return {
      showed: false,
      i: 0,
    };
  },
  computed: {
    content() {
      return this.noticias[this.i];
    },
  },
  mounted() {
    if (this.isShowed) this.showed = true;
    this.i = this.index;
    this.showAnimation();
    document.body.style.overflowY = "hidden";
  },
  beforeDestroy() {
    scaleOut(this.$el);
    document.body.style.overflowY = "scroll";
  },
  methods: {
    close() {
      this.$emit("close");
    },
    showAnimation() {
      scaleIn(this.$el.lastChild);
    },
    openBiografia() {
      this.isBiografia = true;
    },
    closeBiografia() {
      this.isBiografia = false;
    },
    anterior() {
      if (this.i === 0) return;
      this.i--;
    },
    proximo() {
      if (this.i === this.noticias.length - 1) return;
      this.i++;
    },
  },
};
</script>


<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(10px);
  opacity: 0;
  transition: all 150ms ease-in 0s;
}
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffffc0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  overflow-y: auto;

  .popup {
    width: 100%;
    min-height: 100%;
    position: relative;
    background-color: white;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    overflow-y: auto;
    height: 100vh;
  }

  .content {
    width: 700px;
    padding: 100px 0px;
    position: relative;

    .manchete {
      font-size: 2rem;
      font-family: Roboto Mono;
      font-weight: 300;
      letter-spacing: -0.1rem;
      line-height: 1;
      margin-bottom: 10px;
    }

    .image-noticia {
      width: 220px;
    }

    .data-e-fonte {
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      .data {
        font-size: 1.2rem;
        font-family: Roboto Mono;
        font-weight: 300;
        margin-bottom: 15px;
      }

      .font {
        margin-bottom: 10px;
        font-size: 1rem;
        color: #626262;
        font-family: Roboto Condensed;
        margin-left: 10px;
      }
    }

    .descricao {
      margin-bottom: 50px;
      font-size: 1rem;
    }

    .conteudo {
      max-height: 300px;
      overflow-y: scroll;
      padding-bottom: 50px;
      margin: 30px 0px;
      padding-right: 30px;

      /deep/ b {
        color: #d01c1f;
      }

      /deep/ span {
        font-weight: bold;
      }

      /deep/ blockquote {
        margin-left: 30px;
        font-style: italic;
      }
    }
  }

  .bi-x {
    font-size: 2.5rem;
    color: #626262;
    position: absolute;
    top: 5px;
    left: 15px;
    cursor: pointer;
    z-index: 9999999;
  }
}

.btn-controls {
  display: flex;
  justify-content: space-between;
  user-select: none;
  margin-top: 80px;
  z-index: 9999999;
  padding: 20px 0;

  .button {
    border: 1px solid #62626280;
    padding: 1px 20px;
    border-radius: 7px;
    cursor: pointer;

    &.disabled {
      opacity: 0.5;
      cursor: initial;
    }

    .icon-l {
      margin-left: 10px;
    }

    .icon-r {
      margin-right: 10px;
    }
  }
}

*::-webkit-scrollbar {
  width: 8px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
  border-radius: 8px;
}

*::-webkit-scrollbar-thumb {
  background: rgb(185, 185, 185);
  border-radius: 8px;
}

@media screen and (max-width: 480px) {
  .backdrop {
    .popup {
      top: 0;
      left: 0;
      position: fixed;
      width: 100%;
      min-height: 100vh;
      height: 100vh;
      max-width: 100vw;
    }

    .content {
      max-width: 100vw;
      padding: 80px 30px;
      padding-bottom: 20px;

      .conteudo {
        max-height: 50vh;
      }
    }
  }

  .btn-controls {
    position: static;
    justify-content: space-between;
    margin-top: 100px;
  }

  *::-webkit-scrollbar {
    width: 4px;
    height: 12px;
  }

  *::-webkit-scrollbar-track {
    background: #e4e4e4;
    border-radius: 8px;
  }

  *::-webkit-scrollbar-thumb {
    background: rgb(185, 185, 185);
    border-radius: 8px;
  }
}
</style>
